'use strict';

import React from 'react';
import {Link} from 'react-router';

require('styles/UserList.scss');

class UserListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: props.users,
      loading: props.loading
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      users: nextProps.users,
      loading: nextProps.loading
    });
  }
  render() {
    return (
      <div className="userlist-component">
        {this.state.users.length === 0 && !this.state.loading ? <p className="text-gray text-center pt-50 fz-16">这里空空如也～～</p> : ""}
        {this.state.users.map(user=>{
          return (
            <Link to={`/user/${user._id}`} className="user" key={user._id}>
              <img className="float-left user-avatar" src={user.avatar} />
              <h4 className="fz-14 mt-5 fw-bold">{user.name}</h4>
              <p className="text-gray mb-0 fz-12">{user.summary ? user.summary : <i>这里空空如也～～</i>}</p>
            </Link>
          );
        })}
      </div>
    );
  }
}

UserListComponent.displayName = 'UserListComponent';
export default UserListComponent;



// WEBPACK FOOTER //
// ./src/components/UserListComponent.js